import { render, staticRenderFns } from "./memberServices.vue?vue&type=template&id=32da8420&scoped=true&"
import script from "./memberServices.vue?vue&type=script&lang=js&"
export * from "./memberServices.vue?vue&type=script&lang=js&"
import style0 from "./memberServices.vue?vue&type=style&index=0&id=32da8420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32da8420",
  null
  
)

export default component.exports